import { render } from "./ManageRole.vue?vue&type=template&id=33d91353&scoped=true"
import script from "./ManageRole.vue?vue&type=script&lang=js"
export * from "./ManageRole.vue?vue&type=script&lang=js"

import "./ManageRole.vue?vue&type=style&index=0&id=33d91353&scoped=true&lang=scss"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d91353"]])

export default __exports__